import { mapState, mapActions, mapGetters } from 'vuex';

export default {
  props: {
    content: {
      type    : Object,
      default : ''
    },
    title: {
      type    : String,
      default : ''
    }
  },
  data() {
    return {
      collabLink         : null,
      recordList         : [],
      isLoadingRecords   : false,
      isLoadingAccessUrl : false,
      isProcessingRecord : false,
      openRecordList     : false
    };
  },
  watch: {
    'content.contextId': {
      handler: function() {
        if (this.content.hasEnded && this.content.type === 'collab') {
          this.getRecords();
        };
      },
      deep: true
    }
  },
  mounted() {
    if (this.content.type === 'collab') {
      if (this.content.hasEnded) {
        this.getRecords();
      } else {
        this.getCollabURL();
      }
    }
  },
  computed: {
    ...mapState({
      language: state => state._core.locales.current
    }),
    ...mapGetters({
      getEmail          : '_core/user/getEmail',
      getName           : '_core/user/getName',
      enrollmentContext : 'plataforma/enrollment/getterEnrollmentContext'
    }),
    isMobile() {
      return this.$vuetify.breakpoint.xs;
    }
  },
  methods: {
    ...mapActions({
      actionGetCollabURL       : 'plataforma/content/actionGetCollabURL',
      actionGetCollabRecords   : 'plataforma/content/actionGetCollabRecords',
      actionGetCollabRecordURL : 'plataforma/content/actionGetCollabRecordURL'
    }),
    getRecordDescription(length) {
      switch (length) {
        case 0:
          return this.$t('contentType.webconference.eventEnded');
        case 1:
          return this.$t('contentType.webconference.watchRecord');
        default:
          return this.$t('contentType.webconference.availableRecordings');
      }
    },
    getRecordIcon(length) {
      switch (length) {
        case 1:
          return 'mdi-play-circle-outline';
        default:
          return 'mdi-chevron-down';
      }
    },
    getJoinDescription() {
      if (this.content.allowJoinWebconference) {
        return this.$t('contentType.webconference.joinConference');
      } else {
        return this.$t('contentType.webconference.soon');
      }
    },
    async getRecords() {
      this.isLoadingRecords = true;

      try {
        const { results } = await this.actionGetCollabRecords({ contextId: this.content.contextId });
        this.recordList = results;
        this.isProcessingRecord = this.recordList.some(record => record.status === 'PROCESSING');
        await this.getRecordsURL(this.recordList);
      } catch (err) {
        this.$toast.error(this.$t('contentType.webconference.errorOnAccessRecord'));
      } finally {
        this.isLoadingRecords = false;
      }
    },
    checkRecordsLength(event) {
      if (this.recordList.length === 1) {
        this.openWebConference(event, this.recordList[0].url);
      } else {
        this.openRecordList = true;
      }
    },
    async getRecordsURL(recordList) {
      for (const record of recordList) {
        if (record.status === 'PROCESSING') {
          this.$toast.error(this.$t('contentType.webconference.proccessingRecord'));
        } else if (record.status === 'DONE') {
          const { url } = await this.actionGetCollabRecordURL({ recordId: record.id });

          record.url = url;
        } else {
          this.$toast.error(this.$t('contentType.webconference.errorOnAccessRecord'));
        }
      }
    },
    async getCollabURL() {
      this.$nuxt.$loading.start();

      this.isLoadingAccessUrl = true;

      const data = {
        sessionId : this.content.link,
        email     : this.getEmail,
        name      : this.getName
      };

      try {
        const url = await this.actionGetCollabURL(data);

        this.collabLink = url;
      } catch (err) {
        this.$toast.error(this.$t('contentType.webconference.linkGeneratorError'));
      } finally {
        this.isLoadingAccessUrl = false;
        this.$nuxt.$loading.finish();
      }
    },
    openWebConference(e, url) {
      if (this.content.type === 'collab' && url) {
        e.preventDefault();
        this.emitProgress();
        window.open(url);
      } else if (this.content.link) {
        this.emitProgress();
        window.open(this.content.link);
      }
    },
    emitProgress() {
      this.$nuxt.$emit('student-section', {
        type : 'markProgress',
        data : this.content.topicId
      });
    }
  }
};
